import React from 'react';
import { LuBookOpen, LuChevronRight } from 'react-icons/lu';
import Card from '../../common/Card';

/**
 * The subjects in a student's report. Each opens the subject's chapter-wise report.
 */
export default function StudentReportSubjectsList({ subjects, onSelectSubject }) {
    if (!subjects || !Array.isArray(subjects) || subjects.length === 0) {
        return null;
    }

    return (
        <Card title="Subjects" subtitle="Open a subject to see chapter-wise results and skills">
            <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                {subjects.map((subject, subjectIndex) => (
                    <button
                        key={subjectIndex}
                        type="button"
                        onClick={() => onSelectSubject && onSelectSubject(subject)}
                        className="group flex items-center gap-3 rounded-lg border border-ui-line px-3.5 py-3 text-left transition-colors hover:border-brand-300 hover:bg-ui-brand-soft dark:hover:border-brand-500/40"
                    >
                        <LuBookOpen aria-hidden className="size-4 shrink-0 text-ui-ink-3 group-hover:text-brand-600" />
                        <span className="min-w-0 flex-1 truncate text-sm font-medium text-ui-ink">{subject.subjectName}</span>
                        <LuChevronRight aria-hidden className="size-4 shrink-0 text-ui-ink-3 transition-transform group-hover:translate-x-0.5" />
                    </button>
                ))}
            </div>
        </Card>
    );
}
